import * as yup from "yup";

export const validationSchema = () => {
  let shapes = {
    name: yup.string().required(),
  };

  return yup.object().shape(shapes);
};
